/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    if (!this.container) return;
    if (this.container.cbmSearchController) return this.container.cbmSearchController;
    this.container.cbmSearchController = this;
    this.form = this.container.querySelector('form.searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.defaultTab = this.container.querySelector('.side-panel-content--initial');
    this.predictiveSearchResults = this.container.querySelector('.side-panel-content--has-tabs');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', () => {
      clearTimeout(this.inputTimer);
      this.request?.abort();
      this.request = null;
      this.predictiveSearchResults.classList.remove('loading');
      this.predictiveSearchResults.classList.remove('active');
      this.inputTimer = setTimeout(() => this.onChange(), 300);
    });

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.getElementsByTagName("body")[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
        customElements.get('side-panel-close')?.syncPanelState(this.container);
        customElements.get('side-panel-close')?.syncScrollLock();
        if (this.container.classList.contains('active')) {
          this.container.cbmReturnFocus = item;
          setTimeout(function () {
            if (!_this.container.classList.contains('active')) return;
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          document.dispatchEvent(new CustomEvent('search:open'));
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }
    this.predictiveSearchResults.classList.add('active');
    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  async getSearchResults(searchTerm) {
    this.request?.abort();
    const controller = new AbortController();
    this.request = controller;
    const current = () => this.request === controller && this.getQuery() === searchTerm;
    this.predictiveSearchResults.classList.add('loading');
    let timer;
    try {
      const text = await Promise.race([
        fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`, { signal: controller.signal })
          .then(response => { if (!response.ok) throw new Error('search-request-failed'); return response.text(); }),
        new Promise((resolve, reject) => { timer = setTimeout(() => {
          controller.abort(); reject(new Error('search-timeout'));
        }, 8000); })
      ]);
      if (!current()) return;
      const content = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
      if (!content) throw new Error('search-content-missing');
      this.renderSearchResults(content.innerHTML);
    } catch (error) {
      if (!current()) return;
      const message = document.createElement('p');
      message.setAttribute('role', 'alert');
      message.textContent = 'Search suggestions are unavailable. You can still view all search results.';
      const submit = document.createElement('button');
      submit.type = 'button';
      submit.textContent = 'View all results';
      submit.addEventListener('click', () => this.form.requestSubmit());
      this.predictiveSearchResults.replaceChildren(message, submit);
    } finally {
      clearTimeout(timer);
      if (this.request === controller) {
        this.request = null;
        this.predictiveSearchResults.classList.remove('loading');
      }
    }
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');


    submitButton?.addEventListener('click', () => {
      _this.form.requestSubmit();
    });
  }

  close() {
    clearTimeout(this.inputTimer);
    this.request?.abort();
    this.request = null;
    this.predictiveSearchResults.classList.remove('loading');
    this.container.classList.remove('active');
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new PredictiveSearch(), { once: true });
} else {
  new PredictiveSearch();
}

